import React, { useEffect, lazy, Suspense } from "react";
import { Navigate, useRoutes } from "react-router-dom";
import DashboardLayout from "./componants/Nav-section/DashboardLayout";
import { useDispatch } from "react-redux";
import { companyProfile } from "./store/profileSlice";
import FallbackLoader from "./componants/FallbackLoader";

import NotFoundPage from "./pages/NotFoundPage";

const Dashboard = lazy(() => import("./pages/Dashboard"));
const Login = lazy(() => import("./pages/Login"));
const Received = lazy(() => import("./pages/Received"));
const Sent = lazy(() => import("./pages/Sent"));
const Reports = lazy(() => import("./pages/Reports"));
const UserProfile = lazy(() => import("./pages/UserProfile"));
const Credits = lazy(() => import("./pages/Credits"));
const CreditHistoryTable = lazy(() =>
  import("./componants/Nav-section/CreditHistoryTable")
);
const RechargeHistoryTable = lazy(() =>
  import("./componants/Nav-section/RechargeHistoryTable")
);
const Credentials = lazy(() => import("./pages/Credentials"));
export default function Router() {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(companyProfile());
  }, []);

  const routes = useRoutes([
    {
      element: <DashboardLayout />,
      children: [
        { element: <Navigate to="/dashboard" />, index: true },
        {
          path: "/dashboard",
          element: (
            <Suspense
              fallback={
                <div>
                  <FallbackLoader />
                </div>
              }
            >
              <Dashboard />
            </Suspense>
          ),
        },
        {
          path: "/received",
          element: (
            <Suspense
              fallback={
                <div>
                  <FallbackLoader />
                </div>
              }
            >
              <Received />
            </Suspense>
          ),
        },
        {
          path: "/sent",
          element: (
            <Suspense
              fallback={
                <div>
                  <FallbackLoader />
                </div>
              }
            >
              <Sent />
            </Suspense>
          ),
        },
        {
          path: "/profile",
          element: (
            <Suspense
              fallback={
                <div>
                  <FallbackLoader />
                </div>
              }
            >
              <UserProfile />
            </Suspense>
          ),
        },
        {
          path: "/reports",
          element: (
            <Suspense
              fallback={
                <div>
                  <FallbackLoader />
                </div>
              }
            >
              <Reports />
            </Suspense>
          ),
        },
        {
          path: "/credits",
          element: (
            <Suspense
              fallback={
                <div>
                  <FallbackLoader />
                </div>
              }
            >
              <Credits />
            </Suspense>
          ),
        },
        {
          path: "/credentials",
          element: (
            <Suspense
              fallback={
                <div>
                  <FallbackLoader />
                </div>
              }
            >
              <Credentials />
            </Suspense>
          ),
        },
        // {
        //   path: "/client-report",
        //   element: (
        //     <Suspense
        //       fallback={
        //         <div>
        //           <FallbackLoader />
        //         </div>
        //       }
        //     >
        //       <ClientReport />
        //     </Suspense>
        //   ),
        // },
        {
          path: "/client-balance",
          element: (
            <Suspense
              fallback={
                <div>
                  <FallbackLoader />
                </div>
              }
            >
              <CreditHistoryTable />
            </Suspense>
          ),
        },
        {
          path: "/client-history",
          element: (
            <Suspense
              fallback={
                <div>
                  <FallbackLoader />
                </div>
              }
            >
              <RechargeHistoryTable />
            </Suspense>
          ),
        },
        {
          path: "/login",
          element: (
            <Suspense
              fallback={
                <div>
                  <FallbackLoader />
                </div>
              }
            >
              <Login />
            </Suspense>
          ),
        },
        {
          path: "*",
          element: <NotFoundPage />,
        },
      ],
    },
  ]);

  return routes;
}
